import { render, staticRenderFns } from "./ShareConfigureForm.vue?vue&type=template&id=473067ee"
import script from "./ShareConfigureForm.vue?vue&type=script&lang=js"
export * from "./ShareConfigureForm.vue?vue&type=script&lang=js"
import style0 from "./ShareConfigureForm.vue?vue&type=style&index=0&id=473067ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports